<template>
  <v-app>
    <v-main>
      <v-container fluid fill-height class="pa-0">
        <v-row no-gutters class="fill-height">
          
          <!-- Left side: OTB Icon & Branding -->
          <v-col cols="12" md="6" class="d-flex flex-column align-center justify-center white pa-8 border-right">
            <v-img src="/otb-logo.png" max-width="350" contain></v-img>
            <p class="subtitle-1 mt-8 text-center grey--text text--darken-1">Welcome to the portal</p>
          </v-col>
          
          <!-- Right side: Login Form -->
          <v-col cols="12" md="6" class="d-flex align-center justify-center grey lighten-4">
            <v-card width="100%" max-width="450" flat class="pa-4">
              <v-card-title class="justify-center mb-4">
                <h2 class="headline font-weight-bold primary--text">Sign In</h2>
              </v-card-title>
              
              <v-card-text>
                <v-form>
                  <v-text-field
                      v-model="credentials.email"
                      prepend-inner-icon="mdi-account"
                      name="email"
                      label="Email Address"
                      placeholder="Email Address"
                      type="email"
                      outlined
                      color="primary"
                  ></v-text-field>
                  
                  <v-text-field
                      v-model="credentials.password"
                      prepend-inner-icon="mdi-lock"
                      :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="showPassword = !showPassword"
                      name="password"
                      label="Password"
                      placeholder="Password"
                      :type="showPassword ? 'text' : 'password'"
                      outlined
                      color="primary"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              
              <v-card-actions class="px-4 pb-4">
                <v-btn color="primary" block large @click="submit" class="font-weight-bold">
                  LOGIN
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>

        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
// import axios from "axios"
import {mapActions, mapGetters} from 'vuex'

export default {
  name: 'Login',
  data() {
    return {
      showPassword: false,
      credentials: {
        email: '',
        password: ''
      }
    }
  },
  computed: mapGetters('auth', ['error']),
  methods: {
    ...mapActions({
      login: 'auth/login'
    }),
    async submit() {
      await this.login(this.credentials);
      
      if (this.error) {
        this.$swal.fire({
          icon: 'error',
          title: 'Login Failed',
          text: this.error
        });
      }
    }
  }
}
;
</script>

<style scoped>
/* Fix for Chrome autofill causing label overlap */
::v-deep input:-webkit-autofill ~ .v-label {
  transform: translateY(-24px) scale(0.75) !important;
  background-color: white !important;
  padding: 0 4px !important;
  z-index: 1 !important;
  opacity: 1 !important;
}
</style>
